import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";

const AddPartner = () => {
  const [partnerData, setPartnerData] = useState({
    companyName: "",
    description: "",
    website: "",
    country: "",
    brochure: "",
    tags: [""],
    files: [],
  });

  const onDrop = useCallback((acceptedFiles) => {
    setPartnerData({ ...partnerData, files: acceptedFiles });
  }, [partnerData]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/*",
    multiple: true,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPartnerData({ ...partnerData, [name]: value });
  };

  const handleTagChange = (index, value) => {
    const newTags = [...partnerData.tags];
    newTags[index] = value;
    setPartnerData({ ...partnerData, tags: newTags });
  };

  const addTag = () => {
    setPartnerData({ ...partnerData, tags: [...partnerData.tags, ""] });
  };

  const removeTag = (index) => {
    const newTags = partnerData.tags.filter((_, i) => i !== index);
    setPartnerData({ ...partnerData, tags: newTags });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("companyName", partnerData.companyName);
    formData.append("description", partnerData.description);
    formData.append("website", partnerData.website);
    formData.append("country", partnerData.country);
    formData.append("brochure", partnerData.brochure);
    formData.append("tags", JSON.stringify(partnerData.tags));
    partnerData.files.forEach((file) => {
        formData.append("photos", file); 
      });
    console.log(partnerData);
    console.log(formData);
    try {
      await axios.post("http://localhost:5000/partners", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("Partner added successfully!");
      setPartnerData({
        companyName: "",
        description: "",
        website: "",
        country: "",
        brochure: "",
        tags: [""],
        files: [],
      });
    } catch (error) {
      alert("Error adding partner");
    }
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold mb-4">Add Partner</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="text"
          name="companyName"
          placeholder="Company Name"
          value={partnerData.companyName}
          onChange={handleChange}
          required
          className="border border-gray-300 p-2 rounded-md"
        />

        <textarea
          name="description"
          placeholder="Description"
          value={partnerData.description}
          onChange={handleChange}
          required
          className="border border-gray-300 p-2 rounded-md h-24"
        />

        <input
          type="url"
          name="website"
          placeholder="Website URL"
          value={partnerData.website}
          onChange={handleChange}
          className="border border-gray-300 p-2 rounded-md"
        />

        <input
          type="text"
          name="country"
          placeholder="Country"
          value={partnerData.country}
          onChange={handleChange}
          required
          className="border border-gray-300 p-2 rounded-md"
        />

        <input
          type="url"
          name="brochure"
          placeholder="Brochure URL"
          value={partnerData.brochure}
          onChange={handleChange}
          className="border border-gray-300 p-2 rounded-md"
        />

        <div
          {...getRootProps()}
          className="border border-dashed border-gray-400 p-6 text-center rounded-md cursor-pointer bg-gray-50"
        >
          <input {...getInputProps()} />
          {partnerData.files.length > 0 ? (
            <p className="text-green-600">{partnerData.files.length} file(s) selected</p>
          ) : isDragActive ? (
            <p className="text-blue-600">Drop the files here...</p>
          ) : (
            <p className="text-gray-600">Drag & drop files (logo & brochure), or click to select</p>
          )}
        </div>

        <div>
          <label className="font-semibold">Tags</label>
          {partnerData.tags.map((tag, index) => (
            <div key={index} className="flex gap-2 mt-2">
              <input
                type="text"
                value={tag}
                onChange={(e) => handleTagChange(index, e.target.value)}
                className="border border-gray-300 p-2 rounded-md flex-grow"
              />
              <button type="button" onClick={() => removeTag(index)} className="text-red-500 font-bold">X</button>
            </div>
          ))}
          <button type="button" onClick={addTag} className="mt-2 text-blue-600">
            + Add Tag
          </button>
        </div>

        <button type="submit" className="bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700">
          Add Partner
        </button>
      </form>
    </div>
  );
};

export default AddPartner;
